import { createSlice } from '@reduxjs/toolkit'

const user = createSlice({
    name: 'user',
    initialState: {
        username: null,
        role: null,
        accessToken: null,
        registered: false,
        
        id: null,


        errors: null,
        language: 'en'
    },
    reducers: {
        setUsername: (store, action) => {
            store.username = action.payload
        },
        setRole: (store, action) => {
            store.role = action.payload
        },
        setAccessToken: (store, action) => {
            store.accessToken = action.payload
        },
        setErrors: (store, action) => {
            store.errors = action.payload
        },
        setLanguage: (store, action) => {
            store.language = action.payload
        },
        setId: (store, action) => {
            store.id = action.payload
          },

        setRegistered: (store, action) => {
            store.registered = action.payload
        }
    }
})


export default user
